import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store';
import { INIT_STORE } from './constants';
import BindEmailPanel from './containers/bindEmailPanel';

const store = configureStore(INIT_STORE);

render(
  <Provider store={store}>
    <BindEmailPanel/>
  </Provider>
  ,
  document.getElementById('ak-container')
);

window.Dplus && window.Dplus.pageDone();



/** WEBPACK FOOTER **
 ** ./src/pages/ucBindEmail/index.jsx
 **/